import React from 'react';
import { NextPage } from 'next';
import { bgMainHeader } from 'images/services';
import { Hero, SEO } from 'templates/layout';
import { IntermodalIcon, MiniTruckIcon, TruckIcon } from 'svgs';
import { DescriptionSection, QuoteSection, TruckListSection } from 'templates/services';
import { CONTACT_US_ROUTE, QUOTE_ROUTE } from 'data/routes';
import SilverSection from 'templates/services/SilverSection';
import { equipmentList } from 'data/page-data/equipment-list';

const ServicesPage: NextPage = () => (
  <>
    <SEO
      title={'Explore the best logistics solutions'}
      description={
        'Make the most from moving your freight within the very least amount of time possible with the help of the best industry experts.'
      }
    />
    <Hero
      title={
        <>
          MOVING <span>FREIGHT</span>
          <br /> THE WAY <span>YOU</span> WANT
        </>
      }
      buttonText={'Get a Quote'}
      text={'We arrange bespoke freight solutions for every customer'}
      image={bgMainHeader}
      link={QUOTE_ROUTE}
    />
    <DescriptionSection
      descriptionItems={[
        {
          svgIcon: <TruckIcon />,
          title: 'Truckload',
          text:
            'Ship your freight using whole space available in a variety of truck types like dry van, flatbeds, oversized and refrigerated.',
        },
        {
          svgIcon: <IntermodalIcon />,
          title: 'Intermodal',
          text: 'Pick intermodal haul to avoid the chance of your freight arriving late and avoid road traffic.',
        },
        {
          svgIcon: <MiniTruckIcon />,
          title: 'LESS-THAN-TRUCKLOAD',
          text:
            'Use the space you need. Not more, not less. Keep your budget under control. LTL allows you to be flexible when moving loads of different sizes.',
        },
      ]}
    />
    <QuoteSection
      text={'BOOK YOUR LOAD NOW'}
      wrapperImage={bgMainHeader}
      buttons={[
        { action: QUOTE_ROUTE, text: 'Get a Quote' },
        { action: CONTACT_US_ROUTE, text: 'Contact Us', variant: 'outlined', color: 'default' },
      ]}
    />
    <SilverSection
      header="PATRON TRUCKING"
      subHeader="The load forward"
      textContentList={[
        {
          title: ' We take care of everything',
          description:
            'We take care of your load from point A to B. You experience no difficulties transporting or receiveing goods. Let us handle that for you.',
        },
        {
          title: ' Your support 24/7',
          description:
            'Our staff is trained to resolve any issues you might come by and ensure you are satisfied with our services.',
        },
      ]}
      staticsList={[
        { quantity: '4.3k', text: 'Happy Customers' },
        { quantity: '17.3M', text: 'Miles Traveled' },
        { quantity: '1k', text: 'Number of Shipments' },
      ]}
    />
    <TruckListSection
      title="An option for any load"
      subTitle="We provide a number of available trucks and trailers suitable for any load type"
      truckList={equipmentList}
    />
  </>
);

export default ServicesPage;
